import React, { useEffect, useState } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
import * as Moment from "moment";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { queryNoteBySessionId } from "../../../store/note/thunkAction";
import { noteAction } from "../../../store/note/slice";
import { listSessionHistoryByRequester } from "../../../store/session/thunkAction";
import { FieldType } from "../../../constant/enums";
import { editRequester } from "../../../store/requester/thunkAction";
import { sendNotifyChatError } from "../../../utils/event";

const ChatDetail = ({ config }) => {
  const { t } = useTranslation();
  const setReplyMessageId = _.get(config, "setReplyMessageId", () => {});
  const params = useParams();
  const dispatch = useDispatch();
  const sessionId = _.get(params, "sessionId");
  const navigate = useNavigate();
  const chatId = _.get(params, "id");
  const [domain, setDomain] = useState("");
  const [isInfoRequester, setIsInfoRequester] = useState(true);
  const [tracking, setTracking] = useState({});
  const [visitorPath, setVisitorPath] = useState([]);
  const [firstPage, setFirstPage] = useState(null);
  const [restPages, setRestPages] = useState([]);
  const [lastPage, setLastPage] = useState(null);
  const [pastVisits, setPastVisits] = useState(0);
  const [attributes, setAttributes] = useState([]);
  const [fields, setFields] = useState([]);
  const [tick, setTick] = useState(0);
  const [name, setName] = useState("");
  const [isEditName, setIsEditName] = useState(false);
  const [phone, setPhone] = useState("");
  const [isEditPhone, setIsEditPhone] = useState(false);
  const [email, setEmail] = useState("");
  const [isEditEmail, setIsEditEmail] = useState(false);

  const requesterManage = useSelector((state) => state.requesterManage);
  const noteManage = useSelector((state) => state.noteManage);
  const sessionManage = useSelector((state) => state.sessionManage);
  const profileFormManage = useSelector((state) => state.profileFormManage);

  const sessionNotes = _.get(noteManage, "sessionNotes", []);
  const skipNote = _.get(noteManage, "skip");
  const limitNote = _.get(noteManage, "limit");
  const totalNote = _.get(noteManage, "total");
  const profileForm = _.get(profileFormManage, "profileForm", {});
  const sessionHistory = _.get(sessionManage, "sessionHistory", []);
  const currentSession = _.get(sessionManage, "session");
  const requester = _.get(requesterManage, "requester");

  const validate = () => {
    if (!name.trim()) {
      sendNotifyChatError(t("widget.name_is_require"));
      return false;
    }

    if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      sendNotifyChatError(t("widget.email_error"));
      return false;
    }

    if (phone.trim() && !/^\d{8,10}$/.test(phone)) {
      sendNotifyChatError(t("widget.phone_error"));
      return false;
    }

    return true;
  };

  const onEditRequester = () => {
    const requesterId = _.get(requester, "_id");
    const isOk = validate();

    if (!isOk) {
      return;
    }
    if (requesterId && currentSession._id) {
      const data = {
        sessionId: currentSession._id,
      };
      if (isEditName) {
        data["name"] = name;
      }
      if (isEditEmail) {
        data["attributes"] = [{ key: "email", value: email }];
      }
      if (isEditPhone) {
        data["attributes"] = [{ key: "phone", value: phone }];
      }
      dispatch(
        editRequester({
          id: requesterId,
          data,
        })
      );
      setIsEditName(false);
      setIsEditEmail(false);
      setIsEditPhone(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEditRequester();
    }
  };

  useEffect(() => {
    setFields(_.get(profileForm, "fields", []));
  }, [profileForm]);

  useEffect(() => {
    const requesterId = _.get(requester, "_id");
    const attributes = _.get(requester, "attributes", []);
    const domain = _.get(requester, "domain", "");
    const name = _.get(requester, "name", "");

    if (requesterId) {
      const phone = _.get(_.find(attributes, { key: "phone" }), "value", "");
      const email = _.get(_.find(attributes, { key: "email" }), "value", "");
      const tracking = _.get(
        _.find(attributes, { key: "tracking" }),
        "value",
        ""
      );
      const visitorPath = _.get(
        _.find(attributes, { key: "visitorPath" }),
        "value",
        "[]"
      );
      const pastVisits = _.get(
        _.find(attributes, { key: "pastVisits" }),
        "value",
        0
      );

      try {
        setTracking(JSON.parse(tracking));
        setVisitorPath(JSON.parse(visitorPath));
      } catch (error) {
        setTracking({});
      }
      setName(name);
      setPhone(phone);
      setEmail(email);
      setAttributes(attributes);
      setDomain(domain);
      setPastVisits(pastVisits);
      dispatch(listSessionHistoryByRequester(requesterId));
    }
  }, [requester, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((prev) => prev + 1);
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const firstPage = _.first(visitorPath) || null;
    const lastPage = _.last(visitorPath) || null;

    setFirstPage(firstPage);

    if (visitorPath.length < 2) {
      setLastPage(null);
      setRestPages([]);
      return;
    }

    setLastPage(lastPage);

    const middle = _.slice(visitorPath, 1, -1);

    const restPages = _.takeRight(middle, 8) || [];

    setRestPages(restPages);
  }, [visitorPath, tick]);

  useEffect(() => {
    dispatch(noteAction.clearNote());
  }, [sessionId, dispatch]);

  useEffect(() => {
    if (sessionId) {
      const filter = { skip: skipNote, limit: limitNote };
      dispatch(
        queryNoteBySessionId({
          sessionId,
          filter,
        })
      );
    }
  }, [sessionId, dispatch, skipNote, limitNote]);

  const getTimeAgo = (timestamp) => {
    let result = "";
    if (!timestamp) {
      return result;
    }
    const now = Moment();
    const lastUpdate = Moment(timestamp);

    const duration = Moment.duration(now.diff(lastUpdate));
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    if (days) result += `${days} days, `;
    if (hours) result += `${hours} hours, `;
    if (minutes) result += `${minutes} minutes `;

    result += !days && !hours && !minutes ? "a few seconds ago" : "ago";

    return result;
  };

  return (
    <div className="chat-tab-right">
      <div className="chat-tab-body px-3 pb-5">
        <div className="h-60 d-flex gap-2 align-items-center">
          <button
            className={
              isInfoRequester
                ? "btn btn-primary btn-sm"
                : "btn border-0 bg-transparent btn-sm"
            }
            onClick={() => setIsInfoRequester(true)}
          >
            {t("agent.chat.requester")}
          </button>
          <button
            className={
              !isInfoRequester
                ? "btn btn-primary btn-sm"
                : "btn border-0 bg-transparent btn-sm"
            }
            onClick={() => setIsInfoRequester(false)}
          >
            {t("agent.chat.served_history")}
          </button>
        </div>
        <div className="bg-gray-light py-2 px-3 rounded-2">
          <div className="d-flex">
            <div className="w-50 border-end border-opacity-25 pe-3">
              <div className="color-gray">{t("agent.chat.past_visits")}</div>
              <div className="fw-semibold">{pastVisits}</div>
            </div>
            <div className="w-50 ps-3">
              <div className="color-gray">{t("agent.chat.past_chats")}</div>
              <div className="fw-semibold">{sessionHistory.length - 1}</div>
            </div>
          </div>
        </div>
        {isInfoRequester ? (
          <div className="d-flex mt-4">
            <div className="w-100">
              {isEditName ? (
                <input
                  type="text"
                  value={name}
                  autoFocus
                  onChange={(e) => setName(e.target.value)}
                  onKeyDown={handleKeyDown}
                  onBlur={() => onEditRequester()}
                  className="form-control fw-semibold"
                />
              ) : (
                <div
                  className="fw-semibold"
                  onClick={() => setIsEditName(true)}
                  style={{ cursor: "pointer" }}
                  title={t("agent.chat.click_to_edit")}
                >
                  {requester.name || "Guest"}
                </div>
              )}
              {fields.map((field) => {
                const key = field.key;
                const fieldType = _.get(field, "fieldType", FieldType.TEXT);
                const title = _.get(field, "title");
                const options = _.get(field, "options", []);

                const isVisible = _.get(field, "isVisible", false);
                const value = _.get(
                  _.find(attributes, { key: key }),
                  "value",
                  ""
                );
                const titleOptions = _.get(
                  _.find(options, { key: value }),
                  "title",
                  ""
                );
                return isVisible && field.key !== "name" ? (
                  <div
                    onClick={() => {
                      if (fieldType === FieldType.EMAIL) {
                        setIsEditEmail(true);
                      }
                      if (fieldType === FieldType.PHONE) {
                        setIsEditPhone(true);
                      }
                    }}
                    {...((fieldType === FieldType.EMAIL ||
                      fieldType === FieldType.PHONE) && {
                      title: t("agent.chat.click_to_edit"),
                    })}
                    key={key}
                    className="d-flex gap-2 align-items-center"
                  >
                    {fieldType === FieldType.TEXT && (
                      <img width="15px" src="/img/chat/t4.png" alt="" />
                    )}
                    {fieldType === FieldType.EMAIL && (
                      <img width="15px" src="/img/chat/t1.png" alt="" />
                    )}
                    {fieldType === FieldType.PHONE && (
                      <img width="15px" src="/img/chat/t2.png" alt="" />
                    )}
                    {fieldType === FieldType.ARENA && (
                      <img width="15px" src="/img/chat/t5.png" alt="" />
                    )}
                    {fieldType === FieldType.DROPDOWN && (
                      <img width="15px" src="/img/chat/t3.png" alt="" />
                    )}
                    <strong>{title}: </strong>
                    {fieldType === FieldType.PHONE && !isEditPhone && (
                      <span>{phone}</span>
                    )}
                    {fieldType === FieldType.PHONE && isEditPhone && (
                      <input
                        type="text"
                        value={phone}
                        autoFocus
                        onChange={(e) => setPhone(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onBlur={() => onEditRequester()}
                        className="form-control fw-semibold"
                      />
                    )}
                    {fieldType === FieldType.EMAIL && !isEditEmail && (
                      <span>{email}</span>
                    )}
                    {fieldType === FieldType.EMAIL && isEditEmail && (
                      <input
                        type="text"
                        value={email}
                        autoFocus
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onBlur={() => onEditRequester()}
                        className="form-control fw-semibold"
                      />
                    )}
                    {fieldType === FieldType.ARENA && <span>{value}</span>}
                    {fieldType === FieldType.TEXT && <span>{value}</span>}
                    {fieldType === FieldType.DROPDOWN && (
                      <span>{titleOptions}</span>
                    )}
                  </div>
                ) : (
                  <div key={key} />
                );
              })}
            </div>
            <img
              className="rounded-circle"
              width="46px"
              height="46px"
              src="/img/chat/avatar.png"
              alt=""
            />
          </div>
        ) : (
          <div
            className="d-flex mt-4"
            style={{
              flexDirection: "column",
            }}
          >
            {sessionHistory.map((session) => (
              <div
                key={session._id}
                className="note-box d-flex gap-2 p-1 px-2 rounded-2"
                style={
                  session._id === currentSession._id
                    ? {
                        color: "#23007D",
                      }
                    : {}
                }
              >
                <img
                  style={{
                    width: "18px",
                    height: "12px",
                  }}
                  className="mt-1"
                  src="/img/chat/icon/ticket.svg"
                  alt=""
                />
                <div>
                  <span className="fw-semibold">
                    {Moment(session.addTime).format("DD/MM/YYYY")}
                  </span>
                </div>
                <button
                  className="note-box-view btn btn-sm btn-gray-light text-nowrap"
                  onClick={() => {
                    navigate(
                      `/chat/${chatId}/message/session-id/${session._id}`
                    );
                  }}
                >
                  {t("agent.chat.view_session")}{" "}
                  <img src="/img/chat/icon/view.svg" alt="" />
                </button>
              </div>
            ))}
          </div>
        )}
        {sessionNotes.length ? (
          <div className="d-flex flex-column gap-1">
            <hr className="my-4" />
            <div className="fw-semibold">{t("agent.chat.session_notes")}</div>
            {sessionNotes.map((note) => (
              <div
                key={note._id}
                className="note-box d-flex gap-2 p-1 px-2 rounded-2"
              >
                <img
                  width="11px"
                  height="15px"
                  className="mt-1"
                  src="/img/chat/icon/note.svg"
                  alt=""
                />
                <div>
                  <span className="fw-semibold">
                    {note.name} {t("agent.chat.noted")}:
                  </span>{" "}
                  {note.content}
                </div>
                <button
                  className="note-box-view btn btn-sm btn-gray-light text-nowrap"
                  onClick={() => {
                    setReplyMessageId(note.messageId);
                  }}
                >
                  {t("agent.chat.view_note")}{" "}
                  <img src="/img/chat/icon/view.svg" alt="" />
                </button>
              </div>
            ))}
            {totalNote > sessionNotes.length && (
              <button
                onClick={() => {
                  dispatch(noteAction.setSkip(sessionNotes.length));
                }}
                className="show-more-button btn-primary"
              >
                {t("agent.chat.show_more")}
              </button>
            )}
          </div>
        ) : (
          <div></div>
        )}
        <hr className="my-4" />
        <div>
          <div className="fw-semibold"> {t("agent.chat.visitor_path")}</div>
          <table className="w-100 align-top">
            <tbody>
              <tr>
                <td className="color-gray pe-3 align-top">
                  {t("agent.chat.domain")}
                </td>
                <td className="align-top">{domain || ""}</td>
              </tr>
              <tr>
                <td className="color-gray pe-3 align-top">
                  {t("agent.chat.location")}
                </td>
                <td className="align-top">{_.get(tracking, "location", "")}</td>
              </tr>
              <tr>
                <td className="color-gray pe-3 align-top">
                  {t("agent.chat.browser")}
                </td>
                <td className="align-top">{_.get(tracking, "browser", "")}</td>
              </tr>
              <tr>
                <td className="color-gray pe-3 align-top">
                  {t("agent.chat.platform")}
                </td>
                <td className="align-top">{_.get(tracking, "platform", "")}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          className="timeline-box mt-4 py-2"
          style={{
            backgroundImage: `url(${"/img/chat/icon/dot.svg"})`,
          }}
        >
          {firstPage && (
            <div
              className="d-flex gap-4 mb-3"
              style={{ cursor: "pointer" }}
              title={_.get(firstPage, "url", "")}
            >
              <img
                className="mt-1"
                width="15px"
                height="15px"
                src="/img/chat/icon/ro1.svg"
                alt=""
              />
              <div className="w-100">
                <div
                  className="mb-1"
                  onClick={() => {
                    const url = _.get(firstPage, "url", "");
                    if (url) {
                      window.open(url, "_blank");
                    }
                  }}
                >
                  {_.get(firstPage, "title", "")}
                </div>
                <div className="color-gray small">
                  {getTimeAgo(_.get(firstPage, "timestamp", 0))}
                </div>
              </div>
            </div>
          )}
          {restPages.map((page, index) => {
            const timestamp = _.get(page, "timestamp", 0);
            const title = _.get(page, "title", "");
            const url = _.get(page, "url", "");
            return (
              <div
                className="d-flex gap-4 mb-2"
                key={index}
                style={{ cursor: "pointer" }}
                title={url}
              >
                {!index ? (
                  <img
                    className="mt-1"
                    width="15px"
                    height="15px"
                    src="/img/chat/icon/ro2.svg"
                    alt=""
                  />
                ) : (
                  <div
                    style={{
                      width: "17px",
                    }}
                  ></div>
                )}
                <div className="w-100">
                  <div
                    className="mb-1"
                    onClick={() => {
                      if (url) {
                        window.open(url, "_blank");
                      }
                    }}
                  >
                    {title}
                  </div>
                  {index === restPages.length - 1 && (
                    <div className="color-gray small">
                      {getTimeAgo(timestamp)}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {lastPage && (
            <div
              className="d-flex gap-4 mb-3"
              style={{ cursor: "pointer" }}
              title={_.get(lastPage, "url", "")}
            >
              <img
                className="mt-1"
                width="15px"
                height="15px"
                src="/img/chat/icon/ro3.svg"
                alt=""
              />
              <div className="w-100">
                <div
                  className="mb-1"
                  onClick={() => {
                    const url = _.get(lastPage, "url", "");
                    if (url) {
                      window.open(url, "_blank");
                    }
                  }}
                >
                  {_.get(lastPage, "title", "")}
                </div>
                <div className="color-gray small">
                  {getTimeAgo(_.get(lastPage, "timestamp", 0))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatDetail;
